export default function buildRoute(routeTemplate, paramObject) {
	let regEx;
	let query;
	let pathParts;
	let templateQuery;
	let queryDelimter = '';

	for (const property in paramObject) {
		if (Array.isArray(paramObject[property]) || property === 'query') {
			const propVal = paramObject[property];

			query = new URLSearchParams();

			if (property === 'query') {
				for (const queryProp in propVal) {
					if (Array.isArray(propVal[queryProp])) {
						propVal[queryProp].forEach(element => {
							query.append(queryProp, getValue(element));
						});
					} else {
						query.append(queryProp, getValue(propVal[queryProp]));
					}
				}
			} else {
				propVal.forEach(element => {
					query.append(property, getValue(element));
				});
			}
		} else {
			regEx = new RegExp(`{${property}}`, 'gi');
			routeTemplate = routeTemplate.replace(
				regEx,
				encodeURIComponent(getValue(paramObject[property]))
			);
		}
	}

	//remove missing params that didn't get replaces
	regEx = new RegExp('{.+?}', 'gi');
	routeTemplate = routeTemplate.replace(regEx, '');

	pathParts = routeTemplate.split('?');

	if (pathParts.length > 1) {
		templateQuery = new URLSearchParams(pathParts[1]);
		routeTemplate = `${pathParts[0]}?${templateQuery.toString()}`;
		queryDelimter = '&';
	} else {
		queryDelimter = '?';
	}

	if (query) {
		routeTemplate = `${routeTemplate}${queryDelimter}${query.toString()}`;
	}

	return routeTemplate;

	function getValue(value) {
		let newValue = value;

		if (newValue === undefined || newValue === null) {
			newValue = '';
		}

		return newValue;
	}
}
